import axios from 'axios';
import { billingHistoryAction } from './BillingHistorySlice';

const getBilligHistoryData = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/subscriptions?page=1&limit=30`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      const billingHistoryData = result.data;
      dispatch(billingHistoryAction.billingHistoryHandler({ billingHistoryData }));
    } catch (e) {}
  };
};

export default getBilligHistoryData;